<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="7" lg="5" xl="4" class="text-center">
        <v-card>
          <v-card-text>
            <v-img
              :src="require('@/assets/logo.png')"
              class="my-3"
              contain
              height="100"
            ></v-img>
            <v-form
              v-model="isValidForm"
              ref="loginForm"
              class="mt-10"
            >
              <v-text-field
                label="Username"
                v-model="userName"
                :rules="[required('Username')]"
                required
                outlined
              />
              <PasswordField
                label="Password"
                :value="password"
                :is-required="true"
                :is-needed-to-validate="false"
                @valueChange="(newValue) => this.password = newValue"
                @keydown.enter.native="handleLoginClick"
              ></PasswordField>
              <v-btn
                class="mt-2"
                :disabled="!isValidForm"
                block color="primary"
                @click="handleLoginClick"
              >Log In</v-btn>
              <v-btn
                class="mt-4 yellow-brand"
                block
                text
                @click="GoToForgotPassword"
              >
                Forgot password?
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'
import { dashboardRoute, forgotPasswordRoute } from '@/lib/constants/routes'
import { PasswordField } from '@/components/shared/textFields'

export default {
  components: {
    PasswordField
  },
  data () {
    return {
      forgotPasswordRoute,
      isValidForm: null,
      userName: null,
      password: null
    }
  },
  computed: {
    ...mapFields('application', [
      'showDrawer'
    ])
  },
  methods: {
    required,
    ...mapActions('authentication', [
      'login'
    ]),
    handleLoginClick () {
      if (!this.$refs.loginForm.validate()) {
        return
      }

      this.login({ userName: this.userName, password: this.password }).then(() => {
        this.showDrawer = true
        this.$router.push(this.$route.query.nextUrl || dashboardRoute)
      })
    },
    GoToForgotPassword () {
      this.$router.push(this.forgotPasswordRoute)
    }
  }
}
</script>
